import { Repository } from './Repository';

export default class ContentRepository extends Repository {
    constructor() {
        super();

        this.contentRequestPrefix = '/api/v1/content';
    }

    getSummaryContents = (url) => {
        return this.getRequestPromise('get', this.contentRequestPrefix + `/${url}`);
    };

    postContent = (url,param) => {
        return this.getRequestPromise('post', this.contentRequestPrefix + `/${url}`,param);
    };

    getContent = (url) => {
        return this.getRequestPromise('get', this.contentRequestPrefix + `/${url}`);
    };

    putContent = (url,param) => {
        return this.getRequestPromise('put', this.contentRequestPrefix + `/${url}`,param);
    };

    getAudio = (filePath) => {
        return this.getRequestPromise('get', this.contentRequestPrefix + `/audio?filePath=${filePath}`);
    }

    postFinalTest = (param) => {
        return this.getRequestPromise('post', this.contentRequestPrefix + `/final-test`,param);
    }
}
